import { useCallback, useEffect, useState } from "react"
import { useApi } from "../api";
import { AppHeader } from "../components/AppHeader"
import { FtxStrategyListItem } from "../components/FtxStrategyListItem";
import { ICargo } from "../interfaces";
import swal from "sweetalert";
import { FtxReservationListItem } from "../components/FtxReservationListItem";
import { useTranslation } from "react-i18next";
import { FtxOrderListItem } from "../components/FtxOrderListItem";
import { ButtonGroup, Dropdown, ToggleButton } from "react-bootstrap";
import { Numeral } from "../components/Numeral";

export const FtxPage = () => {
  const { t } = useTranslation()
  const api = useApi('SAI')
  const [tab, setTab] = useState(0)
  const [isMounted, setIsMounted] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [strategyListItem, setStrategyListItem] = useState<[]>()
  const [reservations, setReservations] = useState([])
  const [orders, setOrders] = useState([])
  const [strategyList, setStrategyList] = useState([])
  const [strategy, setStrategy] = useState('')
  const [amount, setAmount] = useState(0)
  const [totalAccountValue, setTotalAccountValue] = useState<number | null>(null)
  const [freeCollateral, setFreeCollateral] = useState<number | null>(null)
  const [orderFilter, setOrderFilter] = useState('')
  const [deletedFilter, setDeletedFilter] = useState(false);
  const [strategyFilter, setStrategyFilter] = useState<any>([]);
  const [selectedStrtegy, setSelectedStrtegy] = useState(null);
  const [profit, setProfit] = useState<number>(0);

  const getFtxStrategies = useCallback(() => {
    api.getFtxAvailableStrategies((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setStrategyList(cargo.info)
        const items = cargo.info.map((strategy: any) =>
          <FtxStrategyListItem key={strategy['strategy']} strategy={strategy} onSelect={(strategy: string) => {
            setStrategy(strategy)
          }}></FtxStrategyListItem>
        )
        setStrategyListItem(items)
      }
    })
  }, [api])

  const getFtxAccountInfo = useCallback(() => {
    api.getFtxAccountInfo((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setTotalAccountValue(cargo.info['totalAccountValue'])
        setFreeCollateral(cargo.info['freeCollateral'])
      }
    })
  }, [api])

  useEffect(() => {
    if (!isMounted) {
      getFtxStrategies()
      getFtxAccountInfo()
      setIsMounted(true)
    }
  }, [api, getFtxAccountInfo, getFtxStrategies, isMounted])

  const getReservation = () => {
    api.getFtxReservation((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        cargo.info.forEach((reservation: any) => {
          strategyList.forEach((stg) => {
            if (stg['strategy'] === reservation['strategy']) {
              reservation['strategy'] = stg;
            }
          })
        })
        setReservations(cargo.info);
      }
    })
  }

  const getOrders = () => {
    const strategyFilterMap = new Map();
    api.getFtxOrders((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        cargo.info.forEach((order: any) => {
          strategyList.forEach((stg) => {
            if (stg['strategy'] === order['strategy']) {
              strategyFilterMap.set(order['strategy'], stg)
              order['strategy'] = stg;
            }
          })
          setOrders(cargo.info);
        })
        setStrategyFilter(Array.from(strategyFilterMap.values()));
      }
    })
  }

  useEffect(() => {
    let total: number = 0;
    orders.forEach(order => {
      if (order['status'] === 'C' && order['coverOrder'] === order['orderId']) {
        if (selectedStrtegy === null) {
          total += Number(order['profit'])
        } else if (order['strategy']['strategy'] === selectedStrtegy['strategy']){
          total += Number(order['profit'])
        }
      }
    })
    setProfit(total)
  }, [orders, selectedStrtegy])

  const submitReservation = () => {
    setIsLoading(true)
    api.makeFtxReservation(strategy, amount, (cargo: ICargo) => {
      setIsLoading(false)
      if (cargo.returnCode === '000000')
        swal("Good job!", "智能合約已啟動", "success");
      if (cargo.returnCode === '500003')
        swal("Error!", "燃料不足，無法啟動", "error");
    })
  }

  return (
    <>
      <div className="content colorbk" style={{ backgroundImage: `url('https://ai.supercoin.network/img/bgr.jpg')`, backgroundSize: "100% 100%" }}>
        <AppHeader></AppHeader>
        <div className="loginbg" style={{ minHeight: "auto" }}>
          <div className="bg1 p-3 ml-4">
            <img src="https://ai.supercoin.network/img/coin/FTT.png" alt="" style={{ filter: 'drop-shadow(0px 0px 8px #fff)', width: '50px' }} />
          </div>
          <div className="text-white px-3">
            {t('totalAccountValue')} {Number(totalAccountValue).toLocaleString()} U
          </div>
          <div className="text-white px-3 mb-3">
            {t('freeCollateral')} {Number(freeCollateral).toLocaleString()} U
          </div>
        </div>
      </div>

      <div className="bg-white">

        <ul className="nav nav-pills text-dark pt-3" id="pills-tab" role="tablist" style={{ "background": "#fff" }}>
          <li className="nav-item cursor-pointer" role="presentation" onClick={() => { setTab(0) }}>
            <span className={`nav-link text-dark txt-14 font-weight-bold px-2 ${tab === 0 ? 'active' : ''}`} style={{ "borderColor": "#f00" }} id="status-tab"
              data-toggle="pill" role="tab" aria-controls="status" aria-selected="true">{t('contract')}</span>
          </li>
          <li className="nav-item cursor-pointer" role="presentation" onClick={() => { setTab(1); getReservation() }}>
            <span className={`nav-link text-dark txt-14 font-weight-bold px-2 ${tab === 1 ? 'active' : ''}`} style={{ "borderColor": "#f00" }} id="account-tab"
              data-toggle="pill" role="tab" aria-controls="account" aria-selected="false">{t('history')}</span>
          </li>
          <li className="nav-item cursor-pointer" role="presentation" onClick={() => { setTab(2); getOrders() }}>
            <span className={`nav-link text-dark txt-14 font-weight-bold px-2 ${tab === 2 ? 'active' : ''}`} style={{ "borderColor": "#f00" }} id="account-tab"
              data-toggle="pill" role="tab" aria-controls="account" aria-selected="false">{t('tradeHistory')}</span>
          </li>
        </ul>

        <div className="tab-content" id="pills-tabContent">

          {
            tab === 0 && <div className="tab-pane fade show active" id="status" role="tabpanel" aria-labelledby="status-tab">
              <div className="px-3 pt-5">Step 1. {t('pleaseInputInitVol')}</div>
              <div className="px-3 pt-1"><input className="p-2 border rounded" style={{ 'width': '100%', 'textAlign': 'right' }} onChange={(e) => {
                setAmount(Number(e.target.value))
              }} /></div>
              <div className="px-3 pt-4">Step 2. {t('pleaseSelectStategy')}</div>
              <div className="loginmain px-4 px-sm-5" style={{ "borderRadius": "0", "height": "300px", "overflow": "scroll" }}>
                {strategyListItem}
              </div>
              <div className="px-3 pt-4">Step 3. {t('acitvateAiRobot')}</div>
              <div className="px-3 pt-1">
                <input className="btn btn-outline-danger p-2" type="button" value={t('activate')} style={{ 'width': '100%' }} onClick={submitReservation} />
              </div>
              <div className="py-1 px-3 text-sm text-red-500">
                * {t('ftxReservationFeeHint')}
              </div>
            </div>
          }

          {
            tab === 1 && <div className="tab-pane fade show active" id="account" role="tabpanel" aria-labelledby="account-tab">
              <div className="loginmain px-4 px-sm-5" style={{ "borderRadius": "0" }}>
                <ButtonGroup className="mb-2 w-100">
                  <ToggleButton
                    id="toggle-check"
                    type="checkbox"
                    variant="outline-success"
                    value="false"
                    onClick={(e) => {
                      setDeletedFilter(false)
                    }}
                    checked={deletedFilter === false}
                  >
                    進行中
                  </ToggleButton>
                  <ToggleButton
                    id="toggle-check"
                    type="checkbox"
                    variant="outline-success"
                    value="true"
                    onClick={(e) => {
                      setDeletedFilter(true)
                    }}
                    checked={deletedFilter === true}
                  >
                    已取消
                  </ToggleButton>
                </ButtonGroup>
                {
                  reservations.map(reservation => {
                    if (reservation['deleted'] !== deletedFilter) {
                      return null
                    }
                    return (
                      <FtxReservationListItem
                        key={reservation['idFtxReservation']}
                        strategy={reservation['strategy']}
                        reservation={reservation}
                      ></FtxReservationListItem>
                    )
                  })
                }
              </div>

            </div>
          }

          {
            tab === 2 && <div className="tab-pane fade show active" id="account" role="tabpanel" aria-labelledby="account-tab">
              <div className="loginmain px-4 px-sm-5" style={{ "borderRadius": "0" }}>
                {orderFilter === 'C' && <div className="border p-3 my-3 w-100 rounded-lg text-gray-600">
                  <div>獲利金額</div>
                  <div className="text-right text-lg"><Numeral value={profit} /></div>
                </div>}
                <ButtonGroup className="mb-2 w-100">
                  <ToggleButton
                    id="toggle-check"
                    type="checkbox"
                    variant="outline-success"
                    value="C"
                    onClick={(e) => {
                      setOrderFilter('C')
                    }}
                    checked={orderFilter === 'C'}
                  >
                    策略已平倉
                  </ToggleButton>
                  <ToggleButton
                    id="toggle-check"
                    type="checkbox"
                    variant="outline-success"
                    value="P"
                    onClick={(e) => {
                      setOrderFilter('P')
                    }}
                    checked={orderFilter === 'P'}
                  >
                    策略未平倉
                  </ToggleButton>
                </ButtonGroup>
                <Dropdown>
                  <Dropdown.Toggle variant="success" className="w-100">
                    {selectedStrtegy === null ? "篩選策略" : selectedStrtegy['title']}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="w-100">
                    {
                      strategyFilter.map((strategy: any, index: number) => {
                        return <Dropdown.Item key={strategy['strategy']} onClick={() => {
                          setSelectedStrtegy(strategy)
                        }}>{strategy['title']}</Dropdown.Item>
                      })
                    }
                  </Dropdown.Menu>
                </Dropdown>
                {
                  orders.map((order: any) => {
                    if (orderFilter === 'C' && order['coverOrder'] !== order['orderId']) {
                      return null
                    }
                    if (orderFilter === 'P' && order['coverOrder'] === order['orderId']) {
                      return null
                    }
                    if (orderFilter === 'P' && order['status'] === 'C') {
                      return null
                    }
                    if (selectedStrtegy !== null) {
                      if (selectedStrtegy['strategy'] !== order['strategy']['strategy']) {
                        return null
                      }
                    }
                    return (
                      <FtxOrderListItem
                        key={order['idFtxOrder']}
                        strategy={order['strategy']}
                        order={order}
                      ></FtxOrderListItem>
                    )
                  })
                }
              </div>
            </div>
          }
        </div>
        <div style={{ 'height': '100px' }}></div>
      </div>
    </>
  )
}